import type { TextoLiteral } from "../api/types";
import estilos from "./EditorTextoLiteral.module.css";

interface Props {
  idBase: string;
  valores: TextoLiteral[];
  onCambiar: (siguiente: TextoLiteral[]) => void;
  deshabilitado?: boolean;
}

const LIMITE_VALOR = 300;
const LIMITE_ETIQUETA = 40;

// Lista editable de literales inmutables (precio, telefono, fecha, termino
// legal) que el director debe copiar tal cual -- ver pipeline.flyer_agentic
// .TextoLiteral y pipeline/text_gate.py (M6). Componente controlado y sin
// persistencia propia: el llamador (FormularioNuevoProyecto en creacion,
// PanelTextoLiteral en edicion) decide cuando guardar.
export function EditorTextoLiteral({
  idBase,
  valores,
  onCambiar,
  deshabilitado,
}: Props): JSX.Element {
  const agregar = (): void => {
    onCambiar([...valores, { valor: "", etiqueta: "" }]);
  };

  const quitar = (indice: number): void => {
    onCambiar(valores.filter((_, i) => i !== indice));
  };

  const cambiarValor = (indice: number, valor: string): void => {
    onCambiar(
      valores.map((item, i) => (i === indice ? { ...item, valor } : item)),
    );
  };

  const cambiarEtiqueta = (indice: number, etiqueta: string): void => {
    onCambiar(
      valores.map((item, i) => (i === indice ? { ...item, etiqueta } : item)),
    );
  };

  return (
    <div className={estilos.contenedor}>
      {valores.length === 0 && (
        <p className={estilos.vacio}>
          Sin texto literal todavia: todo el copy lo redacta la IA.
        </p>
      )}
      {valores.length > 0 && (
        <ul className={estilos.lista}>
          {valores.map((item, indice) => (
            <li key={indice} className={estilos.fila}>
              <div className={estilos.campoValor}>
                <label htmlFor={`${idBase}-valor-${indice}`}>
                  Texto literal #{indice + 1}
                </label>
                <input
                  id={`${idBase}-valor-${indice}`}
                  type="text"
                  value={item.valor}
                  maxLength={LIMITE_VALOR}
                  placeholder="Ej: (555) 123-4567"
                  disabled={deshabilitado}
                  onChange={(e) => cambiarValor(indice, e.target.value)}
                />
              </div>
              <div className={estilos.campoEtiqueta}>
                <label htmlFor={`${idBase}-etiqueta-${indice}`}>
                  Que es (opcional)
                </label>
                <input
                  id={`${idBase}-etiqueta-${indice}`}
                  type="text"
                  value={item.etiqueta ?? ""}
                  maxLength={LIMITE_ETIQUETA}
                  placeholder="Telefono, precio, fecha..."
                  disabled={deshabilitado}
                  onChange={(e) => cambiarEtiqueta(indice, e.target.value)}
                />
              </div>
              <button
                type="button"
                className="boton boton-peligro"
                onClick={() => quitar(indice)}
                disabled={deshabilitado}
                aria-label={`Quitar texto literal #${indice + 1}`}
              >
                Quitar
              </button>
            </li>
          ))}
        </ul>
      )}
      <button
        type="button"
        className="boton boton-secundario"
        onClick={agregar}
        disabled={deshabilitado}
      >
        + Agregar texto literal
      </button>
    </div>
  );
}
